import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Circular from '../../components/Progress/Circular';
import useTitle from 'hooks/useTitle';
import { useHistory } from 'react-router-dom';
import { useMainStore } from 'useStores/useMainStore';
import axios from '../../api/axios';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Logout = () => {
  useTitle('خروج');
  const history = useHistory();
  const classes = useStyles();
  const [loggedOut, setLoggedOut] = useState(false);
  const setToken = useMainStore((state) => state.setFirebaseToken);
  function handleForceLogout() {
    axios.get('/auth/user/userForceLogout');
  }

  useEffect(() => {
    setToken(null);
    handleForceLogout();
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => setLoggedOut(true), 1000);
  }, []);

  if (loggedOut === false)
    return (
      <div className={classes.root}>
        <Circular text="" />
      </div>
    );
  return (
    <div className={classes.root}>
      <Button
        onClick={() => history.replace('/login')}
        color="secondary"
        variant="contained"
      >
        ورود مجدد
      </Button>
    </div>
  );
};

export default React.memo(Logout);
